module.exports = __webpack_public_path__ + "img/google-contacts.cc342911.png";